<template>
  <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-gap-2 tw-text-gray-500">
    <template v-if="error">
      <span>{{ error }}</span>
      <router-link :to="{ name: 'polling' }" class="tw-text-green-600 tw-underline">Naar de polling-lijst</router-link>
    </template>
    <span v-else>Meter zoeken voor {{ $route.params.locationId }}...</span>
  </div>
</template>

<script setup>
// /v2/polling/location/:locationId: links from an address (tasks, call centre, cases) land here.
// The tickets location lists the meters of the address; we open the polling page on the one that
// communicated last. The detail page is address-centric, so it shows the other meters as well.
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import fetchData from '@/util/fetch'
import { pickMeter } from '@/util/meterLinks'

const route = useRoute()
const router = useRouter()
const error = ref('')

async function resolve(locationId) {
  error.value = ''
  try {
    const response = await fetchData(`/tickets/api/v1/locations/${encodeURIComponent(locationId)}`)
    const serial = pickMeter(response?.data?.eleenas)
    if (!serial) {
      error.value = `Geen meter gevonden op adres ${locationId}`
      return
    }
    router.replace({ name: 'polling-detail', params: { id: serial } })
  } catch (e) {
    error.value = e?.message?.includes('not found')
      ? `Adres ${locationId} is niet bekend in het ticketsportaal`
      : `Meter zoeken mislukt: ${e?.message || e?.detail || e}`
  }
}

watch(() => route.params.locationId, (locationId) => locationId && resolve(locationId), { immediate: true })
</script>
